import React from "react";

const AuthFormTermsAndConditions = () => (
  <div className="text-center mb-2.5 text-onyx">
    By registering, I accept the <br className="md:hidden" />
    <a href="/pages/termsofservice" className="text-onyx font-medium underline" target="_blank">
      Terms of Service
    </a>{" "}
    and{" "}
    <a href="/privacy" className="text-onyx font-medium underline" target="_blank">
      Privacy Policy
    </a>
    .
  </div>
);

export default AuthFormTermsAndConditions;
